import type { FaireProductEntity } from "../../entity_types/product";

export const p_hbqy59h22x: FaireProductEntity = {
  token: "p_hbqy59h22x",
  type: "product",
  name: "Majestic Grand Canyon Grayscale Adult Coloring Book: 48 grayscale coloring pages of grand canyon, Arizona, desert cactus, rock formations, majestic sc - Paperback",
  brandToken: "b_4d6jvdz5w2",
  brandName: "Books by splitShops",
  imageUrl:
    "https://cdn.faire.com/fastly/35f069eaf86e9bd87e06bcdad3802921e51b531f507e186268bd6d2548560ea9.jpeg",
  galleryImageUrls: [],
  priceDollars: 14.94,
  description:
    "by Laura Kilgore (Author)\n\nMajestic Grand Canyon is a Life Escapes grayscale coloring books for adults with 48 grayscale coloring pages of grand canyon, Arizona, desert cactus, rock formations, majestic scenes, mountains, national park, Colorado river and more \n\n\nOriginal images photographed and grayscaled by Laura Kilgore. Downloadable color guide available. \n\nGrayscale images are designed to help you create realistic looking results. Just color over the grays. Light grays for light colors and so on. You can use any mediums you would like. Such as colored pencils, gel pens, markers, makeup, pastel chalks and more. You will find great relaxation and enjoyment in it. Number of Pages: 112 Dimensions: 0.23 x 11 x 8.5 IN Publication Date: September 20, 2020",
  tags: [],
  msrpDollars: 18.68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:21.696Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
